import classNames from "classnames";
import { IconButton } from "components/primitives";
import { WidgetControlClass } from "components/WidgetComponents";
import styled from "styled-components";

import { FONTS } from "./constants";

export const MoveIconBtn = styled(IconButton).attrs({
  className: classNames(WidgetControlClass),
})`
  cursor: move !important;
  position: absolute;
  width: var(--widget-handle-size);
  height: var(--widget-handle-size);
  right: calc(var(--widget-handle-size) / -2 + (var(--widget-handle-size) * 1.5));
  bottom: calc(var(--widget-handle-size) / -2);
`;

const templateForFont = FONTS.map((f) => {
  const formatName = f.replaceAll(" ", "_");

  return `
    .ql-picker.ql-font .ql-picker-label[data-value="${formatName}"]::before,
  .ql-picker.ql-font .ql-picker-item[data-value="${formatName}"]::before {
    font-family: ${f};
    content: "${f}";
  }

  .ql-font-${formatName} {
    font-family: ${f};
  }`;
}).join(" ");

export const RTE = styled("div")<{ isShowToolbar: boolean }>`
  ${templateForFont}
  display: flex;
  flex-direction: column;

  .ql-snow .ql-picker.ql-size .ql-picker-label::before,
  .ql-snow .ql-picker.ql-size .ql-picker-item::before {
    content: attr(data-value);
  }

  .ql-toolbar {
    display: ${(props) => (props.isShowToolbar ? "block !important" : "none !important")};
  }

  .ql-container {
    border-width: ${(props) => (props.isShowToolbar ? "1px 0 0 0" : "0")} !important;
    border-style: solid !important;
    border-color: #dde1e8 !important;
    height: ${(props) => (props.isShowToolbar ? "unset" : "100%")};
    max-height: ${(props) =>
      props.isShowToolbar
        ? "calc(100% - 30px - 4rem)"
        : "100%"}; // prevent the height eating into the toolbar
  }
`;
